import { render, staticRenderFns } from "./PopularityList.vue?vue&type=template&id=5d496939&scoped=true"
import script from "./PopularityList.vue?vue&type=script&lang=js"
export * from "./PopularityList.vue?vue&type=script&lang=js"
import style0 from "./PopularityList.vue?vue&type=style&index=0&id=5d496939&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d496939",
  null
  
)

export default component.exports